import React from 'react';

import RevertChangesDialog from '@/modules/corporate/modules/admin/components/RevertChangesDialog';

import { DialogProps } from '../../types';

const RevertChanges: React.FC<DialogProps> = ({ content, onClose }) => {
  if (!content.id) {
    return null;
  }
  return <RevertChangesDialog contentId={content.id!} onClose={onClose} />;
};

export default RevertChanges;
